<div class="edit-page-root-container auto-discount-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">

            <div class="detail-section">
                <form class="edit-form" [formGroup]="editForm">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50"
                                        [readonly]="autoDiscountInfo.id!==undefined && autoDiscountInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code
                                        should be entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right"> <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Discount name
                                        should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field></div>

                        </div>
                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                            <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length is
                                200.</mat-error>
                        </mat-form-field>
                        <!-- <mat-checkbox formControlName="is_valid">
                             Valid
                        </mat-checkbox> -->

                    </div>
                </form>
            </div>

            <div class="detail-section">
                <div class="content-container">
                    <div class="sub-title">Purchase</div>
                    <div>
                        <mat-form-field style="width:50%;" disabled>
                            <mat-label>Offer Based On</mat-label>
                            <mat-select [(ngModel)]="autoDiscountInfo.purchase_offer_based_on"
                                name="purchase_offer_based_on" [disabled]="isDisabled()">

                                <mat-option [value]="2">Sale item</mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>

                    <div class="input-group">
                        <div>
                            <mat-form-field>
                                <mat-label>Super class</mat-label>
                                <mat-select [(ngModel)]="selectedSuperClassId"
                                    (selectionChange)="onSuperClassChange($event.value)"
                                    (selectionChange)="isSuperClassInvalid = false">
                                    <mat-option *ngFor="let value of mainGroupList" [value]="value.id">
                                        {{ value.name }}
                                    </mat-option>

                                </mat-select>
                                <mat-error *ngIf="isSuperClassInvalid">Super class is required.</mat-error>

                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>

                                <mat-label>Sub class</mat-label>
                                <mat-select [(ngModel)]="selectedSubClassId"
                                    (selectionChange)="onSubClassChange($event.value)"
                                    (selectionChange)="isSubClassInvalid = false">
                                    <mat-option *ngFor="let value of filteredSubGroups" [value]="value.id">
                                        {{ value.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="isSubClassInvalid">Sub class is required.</mat-error>

                            </mat-form-field>
                        </div>


                    </div>

                    <div class="list-container shops">
                        <div class="header">
                            <span>Sale Item ({{ getSelectedCount(saleItemListData) }})</span>


                            <div class="toggle-arrow-container">
                                @if (resetButtonEnabledForSaleItems) {

                                <button mat-flat-button color="warn" class="btn-rest"
                                    (click)="$event.stopPropagation();reset(saleItemListData);">Reset</button>
                                }
                                <!-- Toggle Button -->
                                <button (click)="toggleContent('saleitems')" class="arrow-button">
                                    <svg *ngIf="!isExpandedSaleItems" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none">
                                        <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" fill="none" />
                                    </svg>
                                    <svg *ngIf="isExpandedSaleItems" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none">
                                        <path d="M6 15l6-6 6 6" stroke="currentColor" stroke-width="2" fill="none" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div *ngIf="isExpandedSaleItems" class="list">
                            <div class="item-list all">
                                <ng-container *ngFor="let item of saleItemListData">
                                    <div *ngIf="!item.selected" class="list-item"
                                        (click)="item.selected=!item.selected;  onListSelectionChange('saleitems');">
                                        <div class="name">
                                            <span>{{item.item.name}}</span>
                                        </div>
                                        <div class="selection">
                                            <mat-icon>chevron_right</mat-icon>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="item-list selected">
                                <ng-container *ngFor="let item of saleItemListData">
                                    <div *ngIf="item.selected" class="list-item"
                                        (click)="item.selected=!item.selected; onListSelectionChange('saleitems');">
                                        <div class="name">
                                            <span>{{item.item.name}}</span>
                                        </div>
                                        <div class="selection">
                                            <mat-icon>chevron_left</mat-icon>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="validation-error" *ngIf="saleItemSelectionInvalid">
                        At least one sale item must be selected.
                    </div>

                    <div>
                        <div style="display: flex; align-items: center;">
                            <mat-form-field style="width:50%;">
                                <mat-label>When the quantity is</mat-label>
                                <!-- <input matInput maxlength="50" inputmode="numeric" name="saleitem_qty" min="1" required
                                    (keypress)="onlyNumberKey($event)" [(ngModel)]="autoDiscountInfo.saleitem_qty"
                                    #saleQty="ngModel" #qtyInputRef /> -->
                                <input matInput type="number" name="saleitem_qty" required min="1" maxlength="50"
                                    inputmode="numeric" [(ngModel)]="autoDiscountInfo.saleitem_qty"
                                    (keypress)="onlyNumberKey($event)" #saleQty="ngModel" #qtyInputRef />


                                <mat-error *ngIf="saleQty.invalid && saleQty.touched">
                                    Quantity is required.
                                </mat-error>
                                <mat-error *ngIf="saleQty.errors?.['min'] && saleQty.touched">
                                    Quantity must be greater than 0.
                                </mat-error>
                            </mat-form-field>

                            <span style="margin-right: 8px;">or more</span>


                        </div>



                    </div>

                </div>
            </div>


            <div class="detail-section section-reward-type" style="margin-bottom: 20px;">
                <div class="content-container">
                    <div class="sub-title">Offer</div>
                    <div>
                        <mat-form-field style="width:50%;" disabled>
                            <mat-label>Offer Based On</mat-label>
                            <mat-select [(ngModel)]="autoDiscountInfo.offer_based_on" name="offer_based_on"
                                [disabled]="isDisabled()">

                                <mat-option [value]="2">Sale item</mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>

                    <div class="section-content order-value-discount-item">

                        <!-- <div *ngIf="rewardInfoModel.reward_type  == 5" class="section-content order-value-discount-item"> -->
                        <div class="input-container">
                            <div class="input-row">

                                <label for="name"> get any one of the item below</label>
                                <div class="action-btn-container">
                                    <button mat-flat-button class="action-btn btn-discard"
                                        (click)="removeFromAutoDiscountInfo(0)">
                                        CLEAR
                                    </button>


                                    <button class="pdt-button" mat-flat-button color="primary"
                                        (click)="openSelectionTypeDialog()">
                                        Browse
                                    </button>

                                </div>
                            </div>
                        </div>

                        <div class="input-container">
                            <div class=" offer-item-list-container">

                                @for (offer of autoDiscountInfo.offer.offer; track offer.id; let i = $index) {
                                <div class="input-row offer-item-container">
                                    <!-- <input type="number" id="value{{i}}" placeholder="" [(ngModel)]="offer.variance" required
                  [disabled]="isDisabled()"  [max]="offer.is_percentage ? 100 : null" 
                  (input)="onVarianceInput(offer)"/> -->
                                    <input type="number" id="value{{i}}" placeholder="Enter value"
                                        [(ngModel)]="offer.variance" required [max]="offer.is_percentage ? 100 : null"
                                        (input)="onVarianceInput(offer)" />
                                    <div *ngIf="varianceErrors?.[offer.id]" class="validation-error">
                                        Enter a valid variance <!--{{ offer.is_percentage ? '(1–100%)' : '(> 0)' }}.-->
                                    </div>
                                    <mat-button-toggle-group class="item-offer-percentage-option-grp"
                                        name="fontStyle{{i}}" [(ngModel)]="offer.is_percentage">
                                        <mat-button-toggle [value]="1" [checked]="true">% </mat-button-toggle>
                                        <mat-button-toggle [value]="0">$</mat-button-toggle>
                                    </mat-button-toggle-group>
                                    <label>discount for</label>
                                    <input class="qty-input" type="number" id="myCheckbox{{i}}" [(ngModel)]="offer.qty"
                                        required readonly [disabled]="isDisabled()" />
                                    X
                                    <span><b>{{getSaleItem(offer.id).name }}</b></span>
                                    <mat-icon class="delete-button"
                                        (click)="removeFromAutoDiscountInfo(offer.id)">delete_forever</mat-icon>
                                </div>
                                }

                            </div>
                            <div *ngIf="offerItemListEmpty" class="validation-error">
                                Please add at least one item to the offer list.
                            </div>


                        </div>

                    </div>
                    <mat-checkbox [(ngModel)]="autoDiscountInfo.is_valid" name="is_valid">
                        Valid
                    </mat-checkbox>
                </div>
            </div>








        </div>
    </div>
</div>